"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Errors = void 0;
var _utils = require("../../utils");
const EmptyModule = (param)=>{
    let { debug, modulePosition, layout } = param;
    return (0, _utils.renderOrThrowError)({
        debug,
        message: 'Module must not be empty.',
        modulePosition,
        layout
    });
};
const UnknownTypename = (param)=>{
    let { debug, modulePosition, layout } = param;
    return (0, _utils.renderOrThrowError)({
        debug,
        message: 'Module must have typename specified correctly.',
        modulePosition,
        layout
    });
};
const Errors = exports.Errors = {
    EmptyModule,
    UnknownTypename
};
